import { Component } from '@angular/core'
import { TranslocoModule } from '@jsverse/transloco'
import { NavigationService } from '../../services/navigation.service'


@Component({
   selector: 'app-go-back',
   standalone: true,
   imports: [TranslocoModule],
   templateUrl: './go-back.component.html',
   styles: ''
})
export class GoBackComponent   {

   constructor(private navigation: NavigationService) { }

   shouldShow() {
      return this.navigation.previousUrl !== undefined
   }

   goBack() {
      this.navigation.goBack()
   }
}